<template>
  <div class="login">
    <van-panel title="来访确认" >
      <van-notice-bar
        wrapable
		v-if="!loading"
        :scrollable="false"
        :text="info"/>
	  <van-loading type="spinner" size="24px" v-if="loading" />
	  <template #footer>
		  <van-button plain v-if="showBtn && !loading"  type="primary" size="small" @click="comfirmTokenByWeb()">
			  同意来访
		  </van-button>
	  </template>
    </van-panel>


    <router-view></router-view>

   </div>
</template>

<script>
import { Dialog, Toast, Notify } from 'vant'
import Moment from 'moment'
import { getVistorInfo ,comfirmTokenByWeb } from '../../services/guest.js'

export default {
  name: 'sms',
  components: {
  },
  props: ['id'],
  data () {
    return {
      url: 'http://localhost:8080/#/guestadd/333',
	  token: '',
	  info: '',
	  loading: true,
	  showBtn: false,
    }
  },
  mounted: function () {
	this.token =  this.$route.params.token;
	//alert(this.token)
    this.getVistorInfo();
  },
  methods: {
    handleSmsConfirm() {
      alert(this.token)
    },
	handleClose() {
		window.location.href="about:blank";
		window.close();
	},
    getVistorInfo(){
		let params = {token:this.token};
		getVistorInfo(params).then(res => {
			console.log(res)
			this.info = res.data.data.msg;
			if(res.data.data.code=="1"){
				this.showBtn = true;
			}else{
				this.showBtn = false;
			}
			this.loading = false;
		})
    },
	comfirmTokenByWeb(){
		this.loading = true;
		let params = {token:this.token};
		comfirmTokenByWeb(params).then(res => {
			this.info = res.data.msg;
			this.showBtn = false;
			this.loading = false;
		})
	},
    
  },
}
</script>

<style lang="scss" scoped>
	.van-button{
		margin-right: 35px;
	}
</style>
